// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"76bffcb2","387":"74d87cad"}[chunkId] + ".css";
};